import React from "react";
import Loading from "../../Components/LoadingComponent";

const PingIdentifyApp = () => {
    return <Loading loading={true} />;
};

export default PingIdentifyApp;
